// extracted by mini-css-extract-plugin
export default {"root":"MailchimpSubscribe_root__6zswr marketplaceModalBottomWrapperText","finePrint":"MailchimpSubscribe_finePrint__7UyFl marketplaceModalHelperLink"};